module.exports = __webpack_public_path__ + "static/media/PM137.4d78be5d.png";